module.exports = __webpack_public_path__ + "img/2_142.9111f60b.png";